<template>
    <div class="list-approved-login-requests panel panel-default" data-infinite-scroll>
        <div class="panel-heading">
            <h3>История</h3>
        </div>

        <panel-search @search="search" placeholder="Введите IMEI, логин, e-mail или телефон для поиска" class="panel-search-light"></panel-search>

        <table class="table table-striped">
            <thead>
            <tr>
                <th>Вход в</th>
                <th>Логин</th>
                <th>Устройство (IMEI)</th>
                <th>Телефон</th>
                <th>E-mail</th>
                <th style="text-align: center;">Действие</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="login_request in login_requests">
                <td>{{ login_request.created_at | date_format('DD.MM.YYYY HH:mm') }}</td>
                <td>{{ login_request.user.login }}</td>
                <td>{{ login_request.imei }}</td>
                <td>{{ login_request.user.phone }}</td>
                <td>{{ login_request.user.email }}</td>
                <td style="text-align: center;">
                    <a :href="`/login-requests/${login_request.login_request_id}/deactivate`" class="btn btn-sm btn-delete">Деактивировать</a>
                </td>
            </tr>
            <tr v-if="login_requests != null && login_requests.length < 1">
                <td colspan="6" class="info-zero-request">Нет одобренных заявок</td>
            </tr>
            </tbody>
        </table>

        <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import 'waypoints/lib/jquery.waypoints.js'

    export default {
        data(){
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        asyncComputed: {
            login_requests() {
                return axios
                    .get('/api/login-requests', {
                        params: {
                            q: this.q,
                            limit: this.limit,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.login_requests = this.login_requests.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        },
        mounted() {
            // Infinite scroll
            var infContainer = $('[data-infinite-scroll]')
            if (!infContainer.length) return
            var self = this

            infContainer.waypoint({
                handler: function (direction) {
                    if (direction == 'down' && self.next_page_url) {
                        if (this.triggerPoint >= 0) {
                            self.loadNextPage()
                        }
                    }
                },
                offset: 'bottom-in-view'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// ListApprovedLoginRequests.vue?07043a37